module.exports = __webpack_public_path__ + "img/top_01.e4bc97a.jpeg";